import { twMerge } from 'tailwind-merge';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface ISidebarLayout {
  wrapperClassName?: string;
  className?: string;
  isCollapsed?: boolean;
  showCollapseButton?: boolean;
  onCollapseChange?: (collapsed: boolean) => void;
}

export function SidebarLayout({
  children,
  wrapperClassName,
  className,
  isCollapsed = false,
  onCollapseChange,
  showCollapseButton = false,
}: React.PropsWithChildren<ISidebarLayout>) {
  return (
    <div
      className={twMerge(
        'w-[280px] fixed left-0 top-0 flex h-screen flex-col justify-between transition-all duration-300 ease-in-out',
        isCollapsed && 'w-[80px]',
        className,
        wrapperClassName,
      )}>
      {children}
      {showCollapseButton && (
        <button
          onClick={() => onCollapseChange?.(!isCollapsed)}
          className="absolute -right-3 top-1/2 -translate-y-1/2 bg-white rounded-full p-1.5 shadow-md hover:bg-gray-50 transition-colors border border-gray-100"
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
          {isCollapsed ? (
            <ChevronRight className="w-4 h-4 text-gray-600" />
          ) : (
            <ChevronLeft className="w-4 h-4 text-gray-600" />
          )}
        </button>
      )}
    </div>
  );
}
